var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_144523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_144523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64805 8.35L8.34805 7.65L6.49805 5.8V3.5H5.49805V6.2L7.64805 8.35ZM5.99805 11C5.30638 11 4.65638 10.8687 4.04805 10.6062C3.43971 10.3437 2.91055 9.9875 2.46055 9.5375C2.01055 9.0875 1.6543 8.55833 1.3918 7.95C1.1293 7.34167 0.998047 6.69167 0.998047 6C0.998047 5.30833 1.1293 4.65833 1.3918 4.05C1.6543 3.44167 2.01055 2.9125 2.46055 2.4625C2.91055 2.0125 3.43971 1.65625 4.04805 1.39375C4.65638 1.13125 5.30638 1 5.99805 1C6.68971 1 7.33971 1.13125 7.94805 1.39375C8.55638 1.65625 9.08555 2.0125 9.53555 2.4625C9.98555 2.9125 10.3418 3.44167 10.6043 4.05C10.8668 4.65833 10.998 5.30833 10.998 6C10.998 6.69167 10.8668 7.34167 10.6043 7.95C10.3418 8.55833 9.98555 9.0875 9.53555 9.5375C9.08555 9.9875 8.55638 10.3437 7.94805 10.6062C7.33971 10.8687 6.68971 11 5.99805 11ZM5.99805 10C7.10638 10 8.05013 9.61042 8.8293 8.83125C9.60846 8.05208 9.99805 7.10833 9.99805 6C9.99805 4.89167 9.60846 3.94792 8.8293 3.16875C8.05013 2.38958 7.10638 2 5.99805 2C4.88971 2 3.94596 2.38958 3.1668 3.16875C2.38763 3.94792 1.99805 4.89167 1.99805 6C1.99805 7.10833 2.38763 8.05208 3.1668 8.83125C3.94596 9.61042 4.88971 10 5.99805 10Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.6193291c7fbb611c2240f52d25002b5a.svg";
export { ForwardRef as ReactComponent };